export default "__VITE_PUBLIC_ASSET__a6c77ae9__"